import React from 'react';

interface DownArrowIconProps {
  className?: string;
  title?: string;
}

const DownArrowIcon: React.FC<DownArrowIconProps> = ({ className = "w-3 h-3", title }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {title && <title>{title}</title>}
      <path
        d="M6 10L2 4H10L6 10Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DownArrowIcon;
